import React, { useContext, useMemo } from "react";

export const Context = React.createContext();

const FeatureFlagProvider = ({ features, children }) => {
  return <Context.Provider value={features}>{children}</Context.Provider>;
};

export const useFeatureFlag = name => {
  const features = useContext(Context);
  if (features === undefined) {
    throw new Error("useFeatureFlag must be used within a FeatureFlagProvider");
  }

  return useMemo(() => {
    if (typeof features[name] === "undefined") {
      return false;
    }
    return features[name];
  }, [features[name], name]);
};

export default FeatureFlagProvider;
